/* The Rough · Drop landing countdown */
if (!customElements.get('rough-countdown')) {
  class RoughCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.target || '');
      if (Number.isNaN(this.target)) {
        this.hidden = true;
        return;
      }
      this.cells = {
        d: this.querySelector('[data-unit="d"]'),
        h: this.querySelector('[data-unit="h"]'),
        m: this.querySelector('[data-unit="m"]'),
        s: this.querySelector('[data-unit="s"]'),
      };
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      let left = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
      if (left === 0) {
        window.clearInterval(this.timer);
        this.classList.add('is-open');
        this.textContent = this.dataset.openText || '';
        return;
      }
      const d = Math.floor(left / 86400);
      left -= d * 86400;
      const h = Math.floor(left / 3600);
      left -= h * 3600;
      const m = Math.floor(left / 60);
      const s = left - m * 60;
      const pad = (n) => String(n).padStart(2, '0');
      this.cells.d.textContent = pad(d);
      this.cells.h.textContent = pad(h);
      this.cells.m.textContent = pad(m);
      this.cells.s.textContent = pad(s);
    }
  }
  customElements.define('rough-countdown', RoughCountdown);
}
